import {makeStyles} from '@material-ui/core';

export default makeStyles(theme => ({
  dialogContent: {
    padding: 24
  },
}))